import React from 'react'
import styled from 'styled-components'
import { Flex, Link, Text, getPaletteColor } from 'pcln-design-system'
import { ArrowRight } from 'pcln-icons'
import { Referral } from '@/types'
import { getLink } from './utils'

const Container = styled(Flex)`
  box-shadow: rgb(0 0 0 / 24%) 0px 0px 1px 0px,
    rgb(0 0 0 / 16%) 0px 2px 1px -1px, rgb(0 0 0 / 12%) 0px 2px 4px 0px;
`

const StyledLink = styled(Link)`
  flex: 1 1 auto;
  display: flex;
  &:active,
  &:focus,
  &:visited,
  &:hover {
    color: ${getPaletteColor('text.lightest')};
    text-decoration: none;
  }
`

const AppIcon = () => (
  <svg width="72" height="72">
    <image
      width="72"
      height="72"
      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAByCAMAAAC4A3VPAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACtVBMVEUAAAAAqv8AeP8Aef8A d/8AeP8AeP8AeP8AeP8Amf8Ad/8Ad/8Ad/8Ajv8AeP8Aef8AeP8Aev8AeP8A//8Aef8AgP8AeP8A eP8Ad/8Ad/8AeP8Ae/8AeP8Ad/8Fef8Yg/8SgP+YyP+52f9Sov86lf////+92/8Hev+Iv/+82/9p r/+kzv/8/f8ojP+Au/9Inf/T5/9To/+v1P93tv/r9P8Ugf9cqP/4+/8rjf90tP8dhv9Cmv92tf8p jP8Wgv8wkP9iq/9HnP8Mff89l/8CeP8xkf8tj/8LfP8DeP8+mP+Nwv+DvP8Ie/8hiP9xs/+SxP+j zf+Lwf9Qof8Eef8kiv8vkP8chf9jq/96uP9Bmf9tsf+RxP+Owv9VpP8Gev+byf+w1P/1+f9krP80 kv+p0f/l8f+72v9Amf/Y6v/s9P9eqf8Ofv+gzP/j8P+Vxv9WpP94t//7/P/B3f8Pf/8KfP/+/v/o 8v+Fvf/5+//6/P/a6/8Je//F4P+Uxf+Mwf/9/f9Uo/+y1f9fqf+Pw//e7f/k8P+Txf+Xx//y+P+E vf/b6/9Em/+JwP/J4v/A3f/V6P9ztP/i7/9orv9Dmv+CvP/3+v8Vgv+lz/8Bd/+hzP8eh/9wsv/g 7v8qjf+q0f/z+P/u9f98uf9vsv/p8/8fh/8ni/8Tgf9mrf9Ln/+izf8bhf85lf+42f/2+v8sjv/H 4f8zkv/L4//n8v9usf9dqP/W6f+z1v8ahP/D3/9+uv/f7f/I4f+u0/8RgP/0+f+cyv9gqv+t0/8g iP9Zpv91tf+ayf+ey//X6f9ap//N5P81k/99uf/Z6v9Fm//U6P/t9f9GnP/M4/+Gvv8ZhP/w9/+s 0v+32P/G4P+o0P95t/8uj/8mi/9Jnf+Qw/9/uv9hqv9Knv+n0P/R5v++3P+Bu/84lP/Q5f+v8YJH AAAAHXRSTlMAAzVymsLf7PkFT6vwCXlj5EnVAYUMsCDS6aw2m/ImqpAAAAABYktHRCXDAckPAAAA B3RJTUUH5AUTDyklz1OIpAAABPBJREFUaN7tm4tbFFUUwGd3gcUFAXmpwGFVvFEGYlHaQwhiVQQl ZXmYGVmGkZaGgEKWlEZiJZWlkRqSmZZZGj3NB2CW9i572mt7/x2de2cfw+5l4MOZud/nN+f7ds65 95yd38yde8/sfnNGkjhisdrCwiPskTBiibRHhIfZrBZpWDLKERU9ctZAiY5yjBoSODrGrhVPFnvM aFWgJTZOWyCVuFiV8R0Trz2QSvyYQYAJifoAqSQm8IhJyfoRAZKTQoljx+lJBBg3NoQ4Xl8iwPgg ZpLO58jOc8DYJuh6HX2SrJxDOs5VpSQq1qMxRAD/+rTolAFCJd6Xh2KNIgLEejO5Dnl1MImTc3yM cUSAGHZ/1PhupS52ev90GEkEcCAyxVhkFK4QzX51DE+iLVKqsUQAq2QzGmmT0oxGpknhRiPDpQij kRGSoYmAil26gH8BI5NIyWgigIk0kSbSRJpIE2kiL1ZkutPpnKAtcsLESRlq/smEkEsAMi+9bIpW yMsJycoeGjkVVY5GyGm4ryuGRl6JKlcjJB7+VVcPjZxOyIxrNEJCxrXXqbm9SLh+5rCISmReXl4+ 3FCQW8im341FRUXZ4Jo1G2ajNYd2Fc/NLSnNmMeC55fdtGBhuVuBrMAwHIxKFKiqLl10s0vebdXi WxYsubWGi8Rv3rYUN+T2O7C1DI07p9eSEliOViX23FVHneTuFQAr72EmuXduALkK1WqALFT31VPn mgZ0Nq5qYpFrCwdBym5C1snIZvz4kTktXuf989Y/4DVJfY4f+WAA6ZUNuGYn+RqtD/GRhDy8cROC WioYkiiQNY+gant0c3vTLNiC5mPVjz+BB9HWwDnLrK0d9DyfBHgK1dPbnnl2O47ODj7yuU6AKaif l5FtC1fv9CJ34XZ3PsALXdC4h5BuNOFF7NvGQe5l85d0g/slvEz7MHIxNmfykS+jTm+nB0iR7ftp v4zswO0B2qyBV9B89SDKa2gc4iBxFqXjNXqduZbSyDfQOMxFdjNjDa4w1xFsvgkBZA9uq+TAt4hC aoOuJY5oEw1qpsi3lZF7uMh3mPEuWu9R5PsB5Bz6pWI5cJNyR6Q45Czr/cijAyIbeMgPmHEMDzQz COmmk9kpB5agebzaJ+6Qswwg6cU+5I9cz0O2nqBJ4CQuIwhCQi1uV8iBZWj2Mis7AziLJIDsw75+ FnnqQ9cgi6QU9WnUH7Hpo0R+jNszeEQrz0IlTRc70ZN5mHySAyoDuw/HpiUPW+7lZFo5H5m1pHxD K+plIchPaXfdZ3s/78mEfjR7dn1x4EvUR9WQ0IudX53+uvobOTNwU4EsXRAysHDO55wI337nj/ze BSrXEk6s9Uf+kM5PeD8y70+NHCScb2bOGec64eet8m5OlhWDKhJ+6ZAjty/yEYOnD/z6W+/vR2hr v8fj+YP1F6LFbi5V5/881j/1IDVdnuN/nfn7H5pYIB/9mGr/RXUKoK+goI/2bvR42GzrPNv1X13H uooAJxhpgJhI/ZH4C9hpMNIoMZEm0kSaSBN5cSEFPIAS8JhNwMNEAY9MDX8wHCbi8bfVaKRVRCmD gIINEWUpAopvBJQYiSikElAuJqIoTkDpn4gCRxFlnAKKVUWU5IooPBZRXi2iiFwSUCoviXghQBLw 2gMrXnWkaPdyR8owXu6QxzfVlnbhr7Ck2VK5I/o/Z+dDnvYkUfwAAAAldEVYdGRhdGU6Y3JlYXRl ADIwMjAtMDUtMTlUMTU6NDE6MzcrMDM6MDDubfKPAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA1 LTE5VDE1OjQxOjM3KzAzOjAwnzBKMwAAAABJRU5ErkJggg=="
    />
  </svg>
)

type AppBannerProps = {
  isAndroid: boolean
  titleText: string
  contentText: string
  pageId: string
  referral: Referral | Record<string, never>
  clientGUID: string
}

export default function AppBanner({
  isAndroid,
  titleText,
  contentText,
  pageId,
  referral,
  clientGUID,
  ...props
}: AppBannerProps & Record<string, unknown>) {
  return (
    <Container
      {...props}
      py={2}
      pl={2}
      pr={12}
      id="app-download-banner"
      className="app-banner"
      fontSize={0}
      borderRadius="xl"
      bg={getPaletteColor('primary.shade')}
    >
      <StyledLink
        color="text.lightest"
        /**
         * TODO: HP_LP_MBL_PROMOBARS seti Cleanup:
         * remove addition of '_v2' from pageId once seti HP_LP_MBL_PROMOBARS declared.
         * v2 was added to distinguish the new addBanner placement (ie the rounded promo bar) for VARIANT
         * */
        href={getLink(isAndroid, referral, clientGUID, `${pageId}_v2`)}
        data-testid="DASH_MWEB_TAB_GET_APP"
        data-ga-category="PCLN_HOME"
        data-ga-action="App_Banner"
        data-ga-label="click to launch"
      >
        <Flex alignItems="flex-start" pl={0} pr={12} py={0}>
          <AppIcon />
        </Flex>
        <Flex flexDirection="column" justifyContent="center">
          <Text textStyle="heading6" mb={1}>
            {titleText}
          </Text>
          <Text textStyle="caption">{contentText}</Text>
        </Flex>
        <Flex alignItems="center" ml="auto">
          <ArrowRight
            title="click to launch app"
            color="text.lightest"
            size={20}
          />
        </Flex>
      </StyledLink>
    </Container>
  )
}
